module.exports = __webpack_public_path__ + "img/slider2.a4d4eed6.svg";